export default {
      id: "oc-res-task-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-task",
      toString: function () {
        return this.url;
      }
    }